import { reverse, routing } from '@utils/routing'

export const getProductHref = (slug: string) => {
  const url = new URL(reverse(routing.productCatalog.product, { slug }), window.location.origin)

  url.searchParams.set('source', 'dashboard-reco')

  return { url: url.toString(), path: url.pathname.toString() }
}
